/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class labordeliverystat extends IceEntity {
  total: number = 0;
  spontaneous_vaginal_total: number = 0;
  assisted_total;
  caesarean_section_total: number = 0;
  complications_total: number = 0;
  preterm_total: number = 0;
  stillbirth_total: number = 0;
  hiv_positive_total: number = 0;
  hiv_positive_live_birth_total: number = 0;
  hepb_positive_total: number = 0;
  hepb_positive_live_birth_total: number = 0;
  hepc_positive_total: number = 0;
  hepc_positive_live_birth_total: number = 0;
  vdrl_positive_total: number = 0;
  vdrl_positive_live_birth_total: number = 0;
  male_live_birth_total: number = 0;
  female_live_birth_total: number = 0;
  unknown_live_birth_total: number = 0;
  male_stillbirth_total: number = 0;
  female_stillbirth_total: number = 0;
  unknown_stillbirth_total: number = 0;
  male_live_birth_lessthan_2_5kg_total: number = 0;
  female_live_birth_lessthan_2_5kg_total: number = 0;
  male_live_birth_greaterthan_2_5kg_total: number = 0;
  female_live_birth_greaterthan_2_5kg_total: number = 0;
  fetus_newborn_complications_total: number = 0;
  fetal_death_total: number = 0;
  maternal_death_total: number = 0;
  no_of_deliveries_under_15: number = 0;
  no_of_deliveries_15_19: number = 0;
  no_of_deliveries_20_24: number = 0;
  no_of_deliveries_25_29: number = 0;
  no_of_deliveries_30_34: number = 0;
  no_of_deliveries_35_39: number = 0;
  no_of_deliveries_40_older: number = 0;
  no_of_deliveries_total: number = 0;
  no_of_male_live_births_under_15: number = 0;
  no_of_male_live_births_15_19: number = 0;
  no_of_male_live_births_20_24: number = 0;
  no_of_male_live_births_25_29: number = 0;
  no_of_male_live_births_30_34: number = 0;
  no_of_male_live_births_35_39: number = 0;
  no_of_male_live_births_40_older: number = 0;
  no_of_male_live_births_total: number = 0;
  no_of_female_live_births_under_15: number = 0;
  no_of_female_live_births_15_19: number = 0;
  no_of_female_live_births_20_24: number = 0;
  no_of_female_live_births_25_29: number = 0;
  no_of_female_live_births_30_34: number = 0;
  no_of_female_live_births_35_39: number = 0;
  no_of_female_live_births_40_older: number = 0;
  no_of_female_live_births_total: number = 0;
  no_of_male_stillbirths_under_15: number = 0;
  no_of_male_stillbirths_15_19: number = 0;
  no_of_male_stillbirths_20_24: number = 0;
  no_of_male_stillbirths_25_29: number = 0;
  no_of_male_stillbirths_30_34: number = 0;
  no_of_male_stillbirths_35_39: number = 0;
  no_of_male_stillbirths_40_older: number = 0;
  no_of_male_stillbirths_total: number = 0;
  no_of_female_stillbirths_under_15: number = 0;
  no_of_female_stillbirths_15_19: number = 0;
  no_of_female_stillbirths_20_24: number = 0;
  no_of_female_stillbirths_25_29: number = 0;
  no_of_female_stillbirths_30_34: number = 0;
  no_of_female_stillbirths_35_39: number = 0;
  no_of_female_stillbirths_40_older: number = 0;
  no_of_female_stillbirths_total: number = 0;
  no_of_multiple_deliveries_under_15: number = 0;
  no_of_multiple_deliveries_15_19: number = 0;
  no_of_multiple_deliveries_20_24: number = 0;
  no_of_multiple_deliveries_25_29: number = 0;
  no_of_multiple_deliveries_30_34: number = 0;
  no_of_multiple_deliveries_35_39: number = 0;
  no_of_multiple_deliveries_40_older: number = 0;
  no_of_multiple_deliveries_total: number = 0;
  no_of_maternal_deaths_under_15: number = 0;
  no_of_maternal_deaths_15_19: number = 0;
  no_of_maternal_deaths_20_24: number = 0;
  no_of_maternal_deaths_25_29: number = 0;
  no_of_maternal_deaths_30_34: number = 0;
  no_of_maternal_deaths_35_39: number = 0;
  no_of_maternal_deaths_40_older: number = 0;
  no_of_maternal_deaths_total: number = 0;

  public gettablename(): string {
    return "LABOR_DELIVERY_STAT";
  }
}
